import MuiDialog from '@mui/material/Dialog';
import SlideTransition from '@/components/SlideTransition';
import MuiList from '@mui/material/List';
import MuiListItem from '@mui/material/ListItem';
import MuiListItemButton from '@mui/material/ListItemButton';
import { type NavigationKey } from '@/constants/navigationKeys';
import { useCurrentUser } from '@/hooks/useStore';
import { isAdmin } from '@/utils/users';
import {
  ADMIN_OPTIONS,
  classes,
  NAVIGATION_OPTIONS,
  type NavigationOption,
} from './utils';

export type NavigationDialogProps = {
  onSelect: (shortcut: NavigationKey) => void;
  onClose: () => void;
};

export default function NavigationDialog({
  onSelect,
  onClose,
}: NavigationDialogProps) {
  const currentUser = useCurrentUser();
  const showAdminOptions = isAdmin(currentUser);

  const renderListItem = ({ name, shortcut }: NavigationOption) => {
    return (
      <MuiListItem key={name} disablePadding>
        <MuiListItemButton
          className={classes.listItemButton}
          onClick={() => onSelect(shortcut)}>
          <div className={classes.shortcut}>{shortcut}</div>
          <div className={classes.name}>{name}</div>
        </MuiListItemButton>
      </MuiListItem>
    );
  };

  return (
    <MuiDialog
      open
      keepMounted
      maxWidth={false}
      TransitionComponent={SlideTransition}
      PaperProps={{
        className: classes.paper,
      }}
      onClose={onClose}>
      <div className={classes.listWrapper}>
        <MuiList className={classes.list}>
          {(showAdminOptions ? ADMIN_OPTIONS : NAVIGATION_OPTIONS).map(
            renderListItem
          )}
        </MuiList>
      </div>
    </MuiDialog>
  );
}
